var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApplyCyber = function SvgApplyCyber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 68"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.16,
    cy: 33.871,
    r: 33.26,
    fill: "#204969"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFF4",
    d: "M50.858 31.917c-2.11.697-2.812 1.4-3.509 3.508a.19.19 0 0 1-.36 0c-.696-2.109-1.399-2.811-3.508-3.508a.19.19 0 0 1 0-.36c2.11-.697 2.812-1.4 3.508-3.509a.19.19 0 0 1 .36 0c.697 2.11 1.4 2.812 3.51 3.509a.19.19 0 0 1 0 .36M52.389 28.453c-1.055.349-1.407.7-1.755 1.755-.029.087-.151.087-.18 0-.348-1.055-.7-1.406-1.755-1.755-.087-.028-.087-.15 0-.18 1.055-.348 1.406-.7 1.755-1.754.028-.087.15-.087.18 0 .348 1.054.7 1.406 1.755 1.754.086.029.086.151 0 .18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFF4",
    strokeMiterlimit: 10,
    strokeWidth: 1.794,
    d: "M24.528 41.31a7.464 7.464 0 1 0 0-14.929 7.464 7.464 0 0 0 0 14.929Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFF4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.794,
    d: "M45.018 39.225a7.464 7.464 0 0 1-10.544.526 7.464 7.464 0 1 1 10.017-11.07M31.75 36.782v5.55"
  })));
};
export default SvgApplyCyber;